import React from 'react';
import { Dialog } from '@headlessui/react';
import { FaSpinner } from 'react-icons/fa';

const LoadingDialog = ({ loading }) => {
  return (
    <Dialog open={loading} onClose={() => {}}>
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm flex flex-col items-center justify-center">
          <FaSpinner className="animate-spin text-red-600 text-3xl mb-4" />
          <p className="text-base text-gray-700">Loading...</p>
        </div>
      </div>
    </Dialog>
  );
};

export default LoadingDialog;
